import React, { useEffect, useState } from 'react';
import CheckoutInput from './CheckoutInput'; // Make sure to provide the correct path to the CheckoutInput component
import { BsFillPersonFill, BsTelephoneFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import { BiLocationPlus } from 'react-icons/bi';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import { addingPhoneNumberToUser, createOrder, updateAllCartItemQuantitiesToZero } from '../api';
import { setCartItems } from '../context/actions/cartActions';
import axios from 'axios';
import { alertNULL, alertSuccess } from '../context/actions/alertActions';
import { useNavigate } from 'react-router-dom';

const CheckoutLeftSection = () => {
    const navigate = useNavigate();
    const [customDateTime, setCustomDateTime] = useState(new Date());
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [address, setAddress] = useState('');
    const [deliveryTime, setDeliveryTime] = useState('');
    const [showCustomTime, setShowCustomTime] = useState(false);
    const [customTime, setCustomTime] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [nameError, setNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [fullAddress, setFullAddress] = useState('');
    const [deliveryTimeError, setDeliveryTimeError] = useState('');
    const [provinces, setProvinces] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState('');
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState('');

    const [isLoading, SetIsLoading] = useState(false)


    const cart = useSelector(state => state.cart) || { items: [] }; // Initialize cart with empty array if it's undefined
    const user = useSelector(state => state.user)
    const generateHash = (user) => {
        const userString = JSON.stringify(user); // Convert user object to a string
        const hash = CryptoJS.SHA256(userString); // Calculate SHA-256 hash
        return hash.toString(CryptoJS.enc.Hex); // Convert the hash to hexadecimal string
    };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^(\+?\d{1,3}[-\s]?)?\d{10}$/;

    const handlePayment = async () => {
        SetIsLoading(true)
        if (!name) {
            setNameError('Tên không được để trống');
            return;
        }
        if (!email || !emailPattern.test(email)) {
            setEmailError('Email không hợp lệ');
            return;
        }
        if (!phoneNumber || !phonePattern.test(phoneNumber)) {
            setPhoneNumberError('Số điện thoại không hợp lệ');
            return;
        }
        if (!address) {
            setAddressError('Địa chỉ không được để trống');
            return;
        }
        if (deliveryTime === 'Thời gian khác' && showCustomTime && !customDateTime) {
            setDeliveryTimeError('Vui lòng chọn ngày và giờ');
            return;
        }

        const orderData = {
            orders: cart.items,
            user: user,
            phoneNumber: phoneNumber,
            address: fullAddress,
            deliveryTime: deliveryTime,
            customTime: customTime,
            paymentMethod: paymentMethod
        }
        setNameError('');
        setEmailError('');
        setPhoneNumberError('');
        setAddressError('');
        if (orderData.phoneNumber !== user.phoneNumber) {
            await addingPhoneNumberToUser(user?.user_id, orderData.phoneNumber);
        }
        try {
            const result = await createOrder(orderData)
            if (result) {
                // Handle success and clear cart
                console.log("Order created:", result);
                try {
                    await updateAllCartItemQuantitiesToZero(user?.user_id);
                    // Create an array of updated cart items with quantity set to 0
                    const updatedCartItems = cart?.items.map((item) => ({
                        ...item,
                        quantity: 0,
                    }));
                    // Dispatch the updated cart items to the Redux store
                    dispatch(setCartItems({ items: updatedCartItems }));
                    dispatch(alertSuccess('Đặt hàng thành công!'))
                    setTimeout(() => {
                        dispatch(alertNULL())
                    }, 3000);
                } catch (error) {
                    console.error("Error clearing cart:", error);
                }
            } else {
                // Handle error
                console.error("Error creating order.");
            }
        } catch (error) {
            console.error('Error creating order:', error);
        }
        SetIsLoading(false)
        navigate("/paymentsuccess");
    }
    const hashedValue = generateHash(user);

    const totalAmount = Array.isArray(cart?.items) ? cart.items.reduce(
        (total, item) => total + parseInt(item.product_price) * item.quantity,
        0
    ) : 0;

    const handleTimeOptionChange = (e) => {
        const selectedTime = e.target.value;
        setDeliveryTime(selectedTime);

        if (selectedTime === 'Thời gian khác') {
            setShowCustomTime(true);
        } else {
            setShowCustomTime(false);
        }
    };

    const generateTimeOptions = () => {
        const availableTimes = [];
        const currentHour = new Date().getHours();

        for (let hour = 0; hour <= currentHour; hour++) {
            availableTimes.push(new Date().setHours(hour, 0, 0, 0));
            availableTimes.push(new Date().setHours(hour, 30, 0, 0)); // Add half-hour interval
        }

        return availableTimes;
    };
    const handleProvinceChange = async (event) => {
        const selectedProvince = event.target.value;
        setSelectedProvince(selectedProvince);
        setSelectedDistrict('');
        setSelectedWard('');
        setAddress('')

        if (selectedProvince) {
            try {
                // Fetch districts based on the selected province
                const response = await axios.get(`https://vn-public-apis.fpo.vn/districts/getByProvince?provinceCode=${selectedProvince}&limit=-1`);
                const districtData = response.data.data.data;
                setDistricts(districtData);
            } catch (error) {
                console.error('Error fetching districts:', error);
            }
        } else {
            setDistricts([]);
            setWards([]);
            setAddress([]);
        }
    };
    const handleDistrictChange = async (event) => {
        const selectedDistrict = event.target.value;
        console.log(selectedDistrict)
        setSelectedDistrict(selectedDistrict);
        setSelectedWard('');
        setAddress('')

        if (selectedDistrict) {
            try {
                // Fetch wards based on the selected district
                const response = await axios.get(`https://vn-public-apis.fpo.vn/wards/getByDistrict?districtCode=${selectedDistrict}&limit=-1`);
                const wardData = response.data.data.data;
                setWards(wardData);
            } catch (error) {
                console.error('Error fetching wards:', error);
            }
        } else {
            setWards([]);
            setAddress([]);
        }
    };
    const handleWardChange = (event) => {
        const selectedWard = event.target.value;
        setSelectedWard(selectedWard);
        setAddress('')

    };
    const generateFullAddress = () => {
        const parts = [];
        if (selectedProvince) parts.push(provinces.find(province => province.code === selectedProvince)?.name);
        if (selectedDistrict) parts.push(districts.find(district => district.code === selectedDistrict)?.name_with_type);
        if (selectedWard) parts.push(wards.find(ward => ward.code === selectedWard)?.name_with_type);
        if (address) parts.push(address);
        return parts.join(', ');
    };

    // Call the generateFullAddress function when any of the relevant values change
    useEffect(() => {
        setFullAddress(generateFullAddress());
    }, [selectedWard, selectedDistrict, selectedProvince, address]);


    useEffect(() => {
        if (user) {
            setName(user.name || '');
            setEmail(user.email || '');
            setPhoneNumber(user.phoneNumber || '');
            setAddress(user.address || '');
        }
    }, [user]);

    useEffect(() => {
        // Fetch provinces data from the API
        axios.get('https://vn-public-apis.fpo.vn/provinces/getAll?limit=-1')
            .then(response => {
                const provinceData = response.data.data.data;
                setProvinces(provinceData);
            })
            .catch(error => {
                console.error('Error fetching provinces:', error);
            });
    }, []);

    useEffect(() => {
    }, [])
    

    return (
        <div className='w-full h-full flex flex-col gap-6 border-4 rounded-md p-4'>
            <div className='flex flex-col gap-2'>
                <div className='text-xl'>Liên hệ</div>
                <CheckoutInput
                    placeHolder='Tên'
                    icon={<BsFillPersonFill />} // Replace with your icon component
                    inputState={name}
                    inputStateFunc={setName}
                    type='text'
                />

                <div className='text-red-500'>{nameError}</div>
                <CheckoutInput
                    placeHolder='Email'
                    icon={<MdEmail />} // Replace with your icon component
                    inputState={email}
                    inputStateFunc={setEmail}
                    type='email'
                />
                <div className='text-red-500'>{emailError}</div>

                <CheckoutInput
                    placeHolder='Số điện thoại'
                    icon={<BsTelephoneFill />} // Replace with your icon component
                    inputState={phoneNumber}
                    inputStateFunc={setPhoneNumber}
                    type='tel'
                />
                <div className='text-red-500'>{phoneNumberError}</div>

            </div>

            <div className='flex flex-col gap-2'>
                <div className='text-xl '>Địa chỉ giao hàng</div>
                <div>
                    {/* <select value={selectedProvince}
                        onChange={handleProvinceChange}
                        className={` block w-full px-4 py-2 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200`}
                        required
                    >
                        <option value="">Chọn tỉnh</option>
                        {provinces.map(province => (
                            <option key={province._id} value={province.code}>
                                {province.name}
                            </option>
                        ))}
                    </select>
                    <select value={selectedDistrict}
                        onChange={handleDistrictChange}
                        className={`${selectedProvince ? '' : 'hidden'} mt-3 block w-full px-4 py-2 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200`}
                        required
                    >
                        <option value="">Chọn huyện</option>
                        {districts.map(district => (
                            <option key={district._id} value={district.code}>
                                {district.name_with_type}
                            </option>
                        ))}
                    </select>
                    <select value={selectedWard}
                        className={`${selectedDistrict ? '' : 'hidden'} mt-3 block w-full px-4 py-2 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200`}
                        onChange={handleWardChange}
                        required
                    >
                        <option value="">Chọn xã/phường</option>
                        {wards.map(ward => (
                            <option key={ward._id} value={ward.code}>
                                {ward.name_with_type}
                            </option>
                        ))}
                    </select> */}
                    {/* Render ward and street select elements */}
                </div>
                <CheckoutInput
                    placeHolder='Số nhà, Đường'
                    icon={<BiLocationPlus />} // Replace with your icon component
                    inputState={address}
                    inputStateFunc={setAddress}
                    type='text'
                />
                <div className='text-red-500'>
                    {addressError || (selectedWard && !address) ? 'Vui lòng nhập địa chỉ đầy đủ' : ''}
                </div>
            </div>
            <div className='flex flex-col gap-2'>
                <div className='text-xl'>Chọn thời gian giao hàng</div>
                <label>
                    <input
                        type='radio'
                        value='ngay bây giờ'
                        name='deliveryTime'
                        onChange={handleTimeOptionChange}
                        checked={deliveryTime === 'ngay bây giờ'}
                    />
                    Ngay bây giờ
                </label>
                <label>
                    <input
                        type='radio'
                        value='Thời gian khác'
                        name='deliveryTime'
                        onChange={handleTimeOptionChange}
                        checked={deliveryTime === 'Thời gian khác'}
                    />
                    Thời gian khác
                </label>
                {showCustomTime && (
                    <div className='flex flex-col gap-2'>
                        <div className='text-sm'>Chọn ngày và giờ:</div>
                        <DatePicker
                            selected={customDateTime}
                            onChange={(date) => setCustomDateTime(date)}
                            showTimeSelect
                            minDate={new Date()} // Minimum selectable date is today
                            excludeTimes={generateTimeOptions()}
                            dateFormat="Pp"
                            className="w-full bg-white backdrop-blur-md rounded-md px-4 py-2 border border-gray-300"
                        />
                        <div className='text-red-500'>{deliveryTimeError}</div>
                    </div>
                )}
            </div>

            <div className='flex gap-10'>
                <div className='flex flex-col'>
                    <div className='text-xl'>Hình thức thanh toán</div>
                    <label>
                        <input
                            type='radio'
                            value='Thanh toán sau'
                            name='paymentMethod'
                            onChange={(e) => setPaymentMethod(e.target.value)}
                            checked={paymentMethod === 'Thanh toán sau'}
                        />
                        Thanh toán khi nhận hàng
                    </label>
                    {/* <label>
                        <input
                            type='radio'
                            value='Thanh toán bằng QR ngân hàng'
                            name='paymentMethod'
                            onChange={(e) => setPaymentMethod(e.target.value)}
                            checked={paymentMethod === 'Thanh toán bằng QR ngân hàng'}
                        />
                        Thanh toán bằng QR ngân hàng
                    </label> */}
                </div>
                {paymentMethod === 'Thanh toán bằng QR ngân hàng' && (
                    <div className='flex flex-col gap-2'>
                        <div className='text-xl'>QR Code Thanh toán</div>
                        <img src={`https://img.vietqr.io/image/techcombank-19033190221012-7ux3Vou.jpg?amount=${totalAmount}&addInfo=${hashedValue}%5C&accountName=${name}`} alt="" className='w-64' />
                    </div>
                )}
            </div>
            <div className='flex justify-end'>
                <button
                    className='bg-green-500 text-white p-4 mt-4 border-2 rounded-md border-green-400'
                    onClick={handlePayment}
                >
                    Thanh toán
                </button>
            </div>
        </div>
    );
};

export default CheckoutLeftSection;
